import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Link } from "react-router-dom";
import { withRedux } from "../hoc";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { LayoutPage, Button, ArticleItem, Image } from ".";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language")
  };
};

@withRedux(mapStateToProps)
export default class DetailPageLayout extends Component {
  static propType = {
    data: PropTypes.shape(),
    page: PropTypes.string,
    path: PropTypes.string,
    media: PropTypes.string,
    imageBanner: PropTypes.string
  };

  getTitleArticle = () => {
    const { page } = this.props;
    switch (page) {
      case "news":
        return "Recent News";
      case "promotions":
        return "Other Promotions";
      case "events":
        return "Other Events";
      case "highlights":
        return "Other Highlights";
      default:
        return "Others";
    }
  };
  getShareUrl = () => {
    const { page, id } = this.props;
    let resource = null;
    switch (page) {
      case "news":
        resource = "posts";
        break;
      case "promotions":
        resource = "promotions";
        break;
      case "events":
        resource = "events";
        break;
      case "highlights":
        resource = "posts";
        break;
      default:
        resource = null;
        break;
    }
    if (!resource) return null;
    const urlShare = `${process.env.REACT_APP_SERVICE}/share/${resource}/${id}`;
    return urlShare;
  };
  render() {
    const { pageName, data, page, id, path, t, media, imageBanner, imageBannerMobile } = this.props;
    let relatedData;
    relatedData = _.filter(data, item => {
      return _.get(item, "id") !== id;
    });
    relatedData = _.slice(relatedData, 0, 3);
    const dataIndex = _.findIndex(data, { id });
    const currentData = _.get(data, dataIndex);
    const nextData = _.get(data, dataIndex + 1);
    const prevData = _.get(data, dataIndex - 1);

    let alignButton;
    if (dataIndex === 0) alignButton = "flex-end";
    else if (dataIndex === _.size(data) - 1) alignButton = "flex-start";
    else alignButton = "space-between";

    let dateItem = _.get(currentData, "date");
    if (
      _.get(currentData, "promotion_start_time") === null ||
      _.get(currentData, "promotion_start_time") === null
    ) {
      dateItem = "";
    }

    const urlShare = this.getShareUrl();

    return (
      <div className="detail-page-layout">
        <LayoutPage
          pageName={pageName}
          media={media}
          image={imageBanner}
          imageMobile={imageBannerMobile}
        />
        <div className="container" style={{ position: "relative" }}>
          <div className="container-all-content">
            <div className="container-image">
              <Image className="background-image" src={_.get(currentData, "image")} alt="" />
              <Image src={_.get(currentData, "image")} alt="" />
            </div>
            <div className="container-social-share">
              <div className="date-content">{dateItem}</div>
              <div className="social-link">
                <FacebookShareButton url={urlShare}>
                  <Button className="button-social facebook">
                    <i className="fa fa-facebook" />
                    Share
                  </Button>
                </FacebookShareButton>
                <TwitterShareButton url={urlShare}>
                  <Button className="button-social twitter">
                    <i className="fa fa-twitter" />
                    Tweet
                  </Button>
                </TwitterShareButton>
                {/* <PinterestShareButton url={urlShare}>
                  <Button className="button-social pinterest">
                    <i className="fa fa-pinterest" />
                    Pin
                  </Button>
                </PinterestShareButton> */}
              </div>
            </div>
            <div className="container-content-detail">
              <div className="detail-title">
                <h2>{t(_.get(currentData, "title"))}</h2>
              </div>
              <div className="detail-content">
                <p
                  className="benefits-detail"
                  dangerouslySetInnerHTML={{ __html: t(_.get(currentData, "description")) }}
                />
              </div>
            </div>
          </div>
          <div className="container-button-pagination" style={{ justifyContent: alignButton }}>
            {dataIndex !== 0 && (
              <div className="button-arrow">
                <Link to={`/${path}/${_.get(prevData, "id")}`}>
                  <div className="arrows">
                    <i className="fa fa-arrow-left" style={{ paddingRight: 7 }} /> {t('Previous')}
                  </div>
                </Link>
                <span>| {t(_.get(data[dataIndex - 1], "title"))}</span>
              </div>
            )}

            {dataIndex !== _.size(data) - 1 && (
              <div className="button-arrow">
                <span>{t(_.get(data[dataIndex + 1], "title"))} |</span>
                <Link to={`/${path}/${_.get(nextData, "id")}`}>
                  <div className="arrows">
                    Next <i className="fa fa-arrow-right" style={{ paddingLeft: 7 }} />
                  </div>
                </Link>
              </div>
            )}
          </div>
          <div className="related-content">
            <div className="related-title">
              <h2>{page && _.size(relatedData) >= 1 && this.getTitleArticle()}</h2>
            </div>
            {_.size(relatedData) >= 1 && (
              <div className="related-content">
                <div className="row">
                  {_.map(relatedData, (item, key) => {
                    return (
                      <div className="col-md-4" key={key}>
                        <div className="container-article-item">
                          <ArticleItem
                            data={item}
                            pathOnClick={`/${path}/${item.id}`}
                            darkFont
                            showDate
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailPageLayout.js